var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ckeditor',{attrs:{"read-only":_vm.isReadOnly,"config":_vm.editorConfig,"value":_vm.value},on:{"ready":_vm.customHandler,"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }